import { AxiosInstance } from "axios";
import { Config } from "types/config";
import { queryOne } from "utils/rest/restApi";

export const getConfig = (axios: AxiosInstance): Promise<Config> => {
  return queryOne<Config>(axios, "config");
};
